import { ButtonsContainer, Title } from '@composites/Gdpr/styles';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ExpandableCardRoot, RegularText, ShowMore } from './styles';

import { RowAlignedItems } from '@components/LinearLayout';
import Toggle from '@components/Toggle';
import { useTranslation } from 'react-i18next';

interface ExpandableCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
  expandedCard?: string;
  setExpandedCard?: Dispatch<SetStateAction<string>>;
  checked?: boolean;
  onClick?: () => void;
}

const ExpandableCard = ({
  title,
  description,
  children,
  checked = false,
  onClick,
  expandedCard = '',
  setExpandedCard,
}: ExpandableCardProps) => {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState<boolean>(false);

  useEffect(() => {
    setExpanded(expandedCard === title);
  }, [expandedCard, title]);

  return (
    <ExpandableCardRoot>
      <ButtonsContainer>
        <Title>{title}</Title>

        {onClick && (
          <RowAlignedItems $gap="1rem">
            <RegularText>{checked ? t('on') : t('off')}</RegularText>
            <Toggle id={title} value={checked} onChange={onClick} />
          </RowAlignedItems>
        )}
      </ButtonsContainer>
      <RegularText>{description}</RegularText>
      <ShowMore
        onClick={() => {
          setExpanded(prevState => !prevState);
          if (expanded) setExpandedCard?.('');
          else setExpandedCard?.(title);
        }}
      >
        {expanded ? t('hide-cookie-information') : t('show-cookie-information')}
      </ShowMore>
      {expanded && children}
    </ExpandableCardRoot>
  );
};

export default ExpandableCard;
